<template>
  <v-container
    class="change-password-view"
    fluid
    fill-height
    align-center
    justify-center
  >
    <v-layout fluid column style="max-width: 250px; height: auto; text-align: center;">
      <form :action="'/users/'+ $store.getters['user/details'].id" @submit.prevent="submit">
        <v-flex class="text-input-container">
          <label> Current Password </label>
          <v-text-field
                  class="lg-text-field"
            v-model="formData.currentPassword"
            solo
            v-validate="'required|min:8|max:50'"
            :error-messages="errors.collect('password')"
            data-vv-name="password"
            name="password"
            type="password"
          ></v-text-field>
        </v-flex>
        <v-flex class="text-input-container">
          <label> New Password </label>
          <v-text-field
            class="lg-text-field"
            v-model="formData.newPassword"
            solo
            v-validate="'required|min:8'"
            :error-messages="errors.collect('New Password')"
            data-vv-name="New Password"
            ref='newPassword'
            type="password"
          ></v-text-field>
        </v-flex>
        <v-flex class="text-input-container">
          <label> Confirm New Password </label>
          <v-text-field
            class="lg-text-field"
            v-model="formData.confirmNewPassword"
            solo
            ref="confirmPassword"
            v-validate="'required|min:8|confirmed:newPassword'"
            data-vv-as="password"
            :error-messages="errors.collect('Confirm New Password')"
            data-vv-name="Confirm New Password"
            type="password"
          ></v-text-field>
        </v-flex>
        <v-btn
              color="accent"
              medium
              depressed=""
              class="submit-button"
              :disabled="!(isTouched && isFormValid)"
              type="submit"
              :loading="submitLoading"
            >
              Submit
            </v-btn>
      </form>
    </v-layout>
  </v-container>
</template>

<script>
import formMixins from '@/mixins/forms'
import userApi from '@/api/user'
import EventBus from '@/event_bus'

import Verte from 'verte'
import 'verte/dist/verte.css'
export default {
  mixins: [formMixins],
  components: { Verte },
  name: 'ChangePasswordView',
  
  data: function() {
    return {
      formData: {
          currentPassword: '',
          newPassword: '',
          confirmNewPassword: ''
        }
    }
  },
  watch: {
    formData: {
      handler: function(val) {
        console.log(this.formData, this.isFormValid)
        if (this.isFormValid) {
          this.$emit('change', this.campaign)
        }
      },
      deep: true
    }
  },
  methods: {
    getFormSubmitPromise: function() {
      return userApi.changePassword(this.$store.getters['user/details'].id, 
        { password: this.formData.currentPassword, 
          new_password: this.formData.newPassword } 
      ).then(function(res){
        EventBus.$emit('SHOW_SNACK', {'msg': 'Password updated'})
      }).catch(function(res){
        console.log(res)
        return Promise.reject(res.response.data.errors)
      })
    }
  }
}
</script>

<style lang="stylus">
.change-password-view {

    .text-input-container {
        margin-bottom 25px
        label {
          color: $color-primary-light-1
          font-weight: 500
        }
    }
    .lg-text-field {
        input {
            font-size 14px
        }
    }

    .lg-select {
        .v-select__selection {
            font-size 14px
        }
    }
    .text-input-container {
        input {
            text-align center
        }
    }
}
</style>